import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  expert: {
    id: 'studio.C4dVmi',
    defaultMessage: 'Expert',
  },
  apps: {
    id: 'studio.gRiKLf',
    defaultMessage: 'Apps',
  },
  notFound: {
    id: 'studio.4KGcV+',
    defaultMessage: 'App collection not found',
  },
  permissionError: {
    id: 'studio.a8h0qp',
    defaultMessage: 'You do not have permission to view this app collection.',
  },
  settings: {
    id: 'studio.D3idYv',
    defaultMessage: 'Settings',
  },
  uncaughtError: {
    id: 'studio.sNygZC',
    defaultMessage: 'There was a problem loading the app collection. Please try again.',
  },
});
